module.exports = __webpack_public_path__ + "img/img2.03b82b94.png";